export default __webpack_public_path__ + "static/media/p2.f1aac2f8.jpg";